<template>
    <a-time-picker
        use12Hours
        :value="modelValue"
        @change="onChange"
        class="appearance-none block w-full"
        placeholder="00:00"
        format="HH:mm:ss"
    />
</template>

<script>
export default {
    props: ['modelValue'],
    methods: {
        onChange(time, timeString) {
            this.$emit('update:modelValue', this.$dayjs(timeString, 'HH:mm:ss'));
        },
    },
};
</script>
